Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (props, propName, componentName, expectedValue) {
  if (props[propName] !== expectedValue) {
    return new Error('\'' + propName + '\' in \'' + componentName + '\'\n\nWoah, hold on player!!!\n\nYou may NOT pass in a prop value for \'' + propName + '\'. ' + 'I mean, bro, it had 2 underscores in the prop name for a reason. Now, if you would kindly remove it, we could all go about our day.\n');
  }
};